<template>
    <div class="launcher-page"> 
        <div class="background"></div>
        <div class="wrapper">
            <div class="form-container">
                <div class="row justify-content-center">
                    <div v-if="statusPage" class="col-lg-4 desktop-consultat-img align-self-end">
                        <img v-if="!statusMessage || statusMessage === '' || statusMessage.length <= 0 || statusMessage === null" src="@/assets/brand/avatar-1.webp" alt="Company Logo" class="img-fluid consultat-img">
                    </div>
                    <div class="col-lg-8">
                        <img v-if="!statusMessage || statusMessage === '' || statusMessage.length <= 0 || statusMessage === null" src="@/assets/brand/qsc-cloud-v5.png" alt="Company Logo" class="img-fluid">
                        <div v-if="statusPage" class="mobile-consultat-img">
                            <img v-if="!statusMessage || statusMessage === '' || statusMessage.length <= 0 || statusMessage === null" src="@/assets/brand/avatar-1.webp" alt="Company Logo" class="img-fluid consultat-img">
                        </div>
                    </div>
                </div>
                <div v-if="statusPage && statusMessage">
                    <div v-html="statusMessage"/>
                </div>
                <div v-if="statusPage" class="status-container">
                    <div v-if="uuid.length > 0 && uuid != 'now' && !statusMessage || statusMessage === '' || statusMessage.length <= 0 || statusMessage === null" class="row justify-content-start m-lg-3 m-2">
                        <div class="col-lg-5">
                            <span><em>Our team will process your request</em></span>
                        </div>
                    </div>
                    <div v-if="statusPage && !statusMessage || statusMessage === '' || statusMessage.length <= 0 || statusMessage === null" class="row justify-content-center m-lg-3 m-sm-2">
                        <div class="col-auto">
                            <p style="margin-bottom: 0px !important;" class="text-body-secondary fw-medium text-start">
                                <b>Welcome to the Quasiris Search Cloud Status Page</b>                     
                            </p>
                        </div>
                    </div>
                    <div class="row justify-content-center me-lg-2">
                        <div class="col-lg-5 offset-lg-7">
                            <div class="d-flex align-items-center float-lg-end">
                                <span>Request-Id:</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                <b  @mouseover="showIdTooltip = true"
                                    @mouseleave="showIdTooltip = false">{{ uuid }}
                                    <span class="copyTooltip fw-semibold" v-if="showIdTooltip" >
                                        Request-Id must be provided when you contact us. 
                                    </span></b>
                                
                                <a @mouseover="showLinkTooltip = true"
                                    @mouseleave="showLinkTooltip = false" href="https://www.docs.qsc-search.de/docs/qsc-admin/admin/launcher/launch-now/" target="_blank" class="text-end ms-2">
                                    <i class="fa-solid fa-circle-info link"></i>
                                    <span class="copyTooltip fw-semibold" v-if="showLinkTooltip" >
                                    Go to Qsc Documentation
                                    </span>
                                </a>
                                
                            </div>
                        </div>
                    </div>
                    <ul class="StepProgress m-5">
                        <li v-for="(step, index) in steps" :key="index" :class="['StepProgress-item', { 'is-done': step.status === 'success', 'current': step.status === 'progress' }]">
                            <strong>{{ step.title }}</strong>
                            <span v-if="step.text">{{ step.text }}</span>
                        </li>
                    </ul>
                </div>
                <div v-if="statusPage" class="row m-lg-3 m-sm-2">
                    <div v-if="stepsbutton.text" class="col-lg-4 offset-lg-8">
                        <a v-if="stepsbutton.view !== 'Hidden'"
                            :href="stepsbutton.url"
                            class="btn launch w-100"
                            :class="{ 'disabled': stepsbutton.view === 'disabled' }"
                            >
                            {{ stepsbutton.text }}
                        </a>              
                    </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3 m-sm-2">
                    <div class="col">
                        <p v-if="!welcomeMessage || welcomeMessage === '' || welcomeMessage.length <= 0 || welcomeMessage === null" class="text-body-secondary fw-medium text-start">
                            <b>Welcome to the Quasiris Search Cloud,</b> With just a few clicks your search will be created
                            <a href="https://www.docs.qsc-search.de/docs/qsc-admin/admin/launcher/launch-now/" target="_blank" class="text-end" data-coreui-toggle="tooltip" title="Go to Qsc Documentation">
                                <i class="fa-solid fa-circle-info link"></i>
                            </a>.
                            Provide us some data as a file upload, paste it to the editor or a download link.
                            If you cannot provide some data, just describe your requirements in the comments and we will create demo data.
                            After launching your search, the data will be processed, the search is configured, and instances are provisioned.
                            <a href="https://www.youtube.com" target="_blank" class="text-end">
                                <i class="fa-brands fa-youtube circle"></i>
                            </a>                        
                        </p>
                        <div v-html="welcomeMessage"/>
                    </div>
                </div>

                <div v-if="launcherPage" class="row m-lg-3 m-sm-2 d-grid gap-2 d-md-flex justify-content-md-end">
                    <div class="col" >
                        <div class="form-floating">
                            <input type="email"
                                class="form-control mb-2" 
                                id="emailInputValue"
                                :class="{ 'is-invalid': !isEmail }"                           
                                v-model="email"
                                autofocus
                                >
                            <label class="form-label" for="emailInputValue">Email address</label>
                        </div>
                    </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3">
                    <div class="col-lg-10">
                        <label for="formFileMultiple" class="col-sm-11 col-form-labellabel label">Upload Data</label>
                    </div>
                    <div class="col-lg-2 d-flex justify-content-end" data-coreui-toggle="tooltip" title="Upload your data"> <i class="fa-solid fa-circle-info text-secondary"></i> </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3 m-sm-2 mb-3" @click="toggleOpacity('Files')">
                        <div class="toolsButtons col-lg-1 align-self-center">
                            <i v-if="showUpload" class="fa-solid fa-circle-check circle"></i>
                            <i v-else class="fa-regular fa-circle circle opacity-75"></i>
                        </div>
                        <div class="col-lg-11" :class="opacities.Files.value" :style="{ pointerEvents: showUpload ? 'auto' : 'none' }">
                            <div v-if="alertUpload" class="alert alert-warning alert-dismissible fade show d-flex align-items-center justify-content-between" role="alert">
                                <div>
                                    <strong>Maximum size: 100 MB</strong> Please zip your file.
                                </div>
                                <i class="fa-solid fa-xmark close-icon" @click="alertUpload = false"></i>
                            </div>
                            <div class="drop-zone" @click="triggerFileInput" @dragover.prevent @drop="handleDrop">
                                <span class="drop-zone__prompt">Drop file here or click to upload (100MB Max)</span>
                                <input type="file" name="myFile" class="drop-zone__input" @change="handleFileUpload">
                                <div v-if="uploadedFiles.length" class="uploaded-files">
                                    <div v-for="(file, index) in uploadedFiles" :key="index" class="uploaded-file">
                                        <span class="file-name">{{ file.name }}</span>
                                        <i class="fas fa-trash-alt delete-icon" @click="deleteFile(index)"></i>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3">
                    <div class="col-lg-10">
                        <label for="formFileMultiple" class="col-sm-11 col-form-labellabel label">Paste Data</label>
                    </div>
                    <div class="col-lg-2 d-flex justify-content-end" data-coreui-toggle="tooltip" title="Paste your data to the editor"> <i class="fa-solid fa-circle-info text-secondary"></i> </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3 m-sm-2 mb-3" @click="toggleOpacity('Paste')">
                        <div class="toolsButtons col-lg-1 align-self-center">
                            <i v-if="showEditor" class="fa-solid fa-circle-check circle"></i>
                            <i v-else class="fa-regular fa-circle circle opacity-75"></i>
                        </div>
                        <div class="col-lg-11" :class="opacities.Paste.value">
                            <v-ace-editor
                                ref="aceRef"
                                v-model:value="formJson"
                                :options="{useWorker: true}"
                                :lang="editorLang"
                                :readonly="!showEditor"
                                @init="editorInit"
                                @change="onChange"
                                :style="{height: '315px'}"
                                theme="nord_dark"
                            />
                        </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3">
                    <div class="col-lg-10">
                        <label for="formFileMultiple" class="col-sm-11 col-form-labellabel label">Link Data</label>
                    </div>
                    <div class="col-lg-2 d-flex justify-content-end" data-coreui-toggle="tooltip" title="Downloadable Link for your data"> <i class="fa-solid fa-circle-info text-secondary"></i> </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3 m-sm-2" @click="toggleOpacity('Link')">
                        <div class="toolsButtons col-lg-1 align-self-center">
                            <i v-if="showLink" class="fa-solid fa-circle-check circle"></i>
                            <i v-else class="fa-regular fa-circle circle opacity-75"></i>
                        </div>
                        <div class="col-lg-11" :class="opacities.Link.value"> 
                            <div class="form-floating">
                            <input type="text"
                                class="form-control mb-3" 
                                id="linkInput" 
                                v-model="link"
                                :readonly="!showLink"
                                autofocus
                                @focus="selectText"
                                :class="{ 'is-invalid': !isLink }"
                                >
                            <label class="form-label" for="linkInput">https://</label>
                            </div>
                        </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3">
                    <div class="col-lg-2 offset-lg-10 d-flex justify-content-end" data-coreui-toggle="tooltip" title="Tell us your requirements"> <i class="fa-solid fa-circle-info text-secondary"></i> </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3 m-sm-2 d-grid gap-2 d-md-flex justify-content-md-end mb-3">
                        <div class="col"> 
                            <div class="form-floating">
                            <textarea id="formTextarea1" 
                            style="width: 100%;height: 110px"
                            v-model="comment"
                            class="form-control"></textarea>
                            <label class="form-label" for="formTextarea1">Comments</label>
                            </div>
                        </div> 
                </div>
                <div v-if="launcherPage" class="row m-lg-3 m-sm-2 mb-5" >
                    <div class="col d-flex align-items-center"> 
                            <i v-if="checkBoxStyle=='border-color:#dc3545;'" class="fa-solid fa-circle-exclamation me-1 text-danger" style="margin-bottom: .125rem;"></i>
                            <div class="form-check">
                                <input 
                                class="form-check-input" 
                                :style="checkBoxStyle"
                                type="checkbox" 
                                id="agreeCheckbox"
                                @click="checkBoxStyle=''" 
                                v-model="agreeChecked">
                                <label class="label" for="agreeCheckbox">
                                    By Launch Now, I agree with Quasiris' <a href="https://qsc.quasiris.de/s/terms-of-service" target="_blank">Privacy Policy</a> and <a href="https://qsc.quasiris.de/s/datenschutz" target="_blank">Terms & Conditions.</a>
                                </label>
                            </div>
                    </div>
                </div>
                <div v-if="launcherPage" class="row m-lg-3 m-sm-2">
                        <div class="col-lg-4 offset-lg-8">
                            <button type="button" class="btn launch w-100" @click="submit">Launch Now</button>
                        </div>
                </div>
            </div>
            <footer class="footer mt-auto">
                <div class="container-fluid">
                    <div class="row align-items-end">
                        <div class="col text-start">
                            <img src="@/assets/brand/logo.png" alt="Logo" style="max-width: 200px;" class="img-fluid">
                        </div>  
                        <div class="col text-end">                        
                            <p style="margin-bottom: 0px !important">Copy right reserved © {{ new Date().getFullYear() }} <a :href="`${hiddenUrl}/` + uuid" target="_blank" style="text-decoration: none; color: inherit; cursor: auto;">Quasiris</a> GmbH</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
        <LauncherOverlay :status="loader" v-if="showOverlay" />
     </div>
 </template>
     
 <script>
   import ace from 'ace-builds';
   import axios from 'axios';
   import workerJavascriptUrl from 'file-loader?esModule=false!ace-builds/src-noconflict/worker-javascript.js';
   ace.config.setModuleUrl('ace/mode/javascript_worker', workerJavascriptUrl);
   import workerJsonUrl from 'file-loader?esModule=false!ace-builds/src-noconflict/worker-json.js'; 
   import workerYamlUrl from 'file-loader?esModule=false!ace-builds/src-noconflict/worker-yaml.js'; 
   import workerXmlUrl from 'file-loader?esModule=false!ace-builds/src-noconflict/worker-xml.js'; 
   ace.config.setModuleUrl('ace/mode/json_worker', workerJsonUrl);
   ace.config.setModuleUrl('ace/mode/yaml_worker', workerYamlUrl);
   ace.config.setModuleUrl('ace/mode/xml_worker', workerXmlUrl);
   import RestResourceService from "@/services/RestResourcesService";
   import getEnv from "@/utils/env";
   import LauncherOverlay from "@/components/overlays/LauncherOverlay";
   import {VAceEditor} from 'vue3-ace-editor';
   import 'ace-builds/src-noconflict/mode-json';
   import 'ace-builds/src-noconflict/mode-xml';
   import 'ace-builds/src-noconflict/mode-yaml';
   import 'ace-builds/src-noconflict/mode-javascript';
   import 'ace-builds/src-noconflict/mode-text';
   import 'ace-builds/src-noconflict/theme-nord_dark';
   import * as jsYaml from 'js-yaml';
   import { onMounted, ref, computed, watch} from 'vue';
   import {useRouter,useRoute} from "vue-router";
   ace.config.set('basePath', '/node_modules/ace-builds/src-noconflict/');

   export default {
     components: {VAceEditor,LauncherOverlay},
     mounted() {
        if(window.uuid != '' && window.uuid.length > 0){
                this.uuid = window.uuid
                this.getData(window.uuid);
            }
    },
    methods:{
        selectText(event) {
            event.target.select();
        },
        editorInit() {

            }
    },
     setup() {
        const isLink = ref(true);
        const isEmail = ref(true);
        const editorLang = ref('javascript'); // default language is 'javascript'
        const alertUpload = ref(false);
        const dataType = ref('javascript');
        const showOverlay = ref(false);
        const loader = ref(false);
        const statusPage = ref(false);
        const launcherPage = ref(false);
        const showIdTooltip = ref(false);
        const showLinkTooltip = ref(false);
        const submitUrl=  `${getEnv("VUE_APP_QSC_ADMIN_UI_URL")}/launcher/launch-now`
        const hiddenUrl=  `${getEnv("VUE_APP_QSC_ADMIN_UI_URL")}/launcher/prepare`
        const submitFilesUrl=  `${getEnv("VUE_APP_QSC_ADMIN_UI_URL")}/launcher/launch-now-multipart`
        const statusUrl=  `${getEnv("VUE_APP_QSC_ADMIN_UI_URL")}/launcher/status/`
        const link = ref('https://qsc.quasiris.de/cdn/qsc/quasiris/qsc/launcher/data/my-data.json');
        let steps = ref([]);
        const router = useRouter();
        const welcomeMessage = ref(null);
        const statusMessage = ref(null);
        const uuid = ref('');
        const checkBoxStyle = ref('');
        const stepsbutton = ref({});
        const comment = ref('');
        const agreeChecked = ref(false);
        const formJson = ref('');
        const uploadedFiles = ref([]);
        const email = ref('');
        const selectedFormat = ref('Paste')
        const opacities = {
            Link: ref('opacity-25'),
            Files: ref('opacity-25'),
            Paste: ref('opacity-100')
        };
        onMounted(() => { 
            formJson.value = JSON.stringify({   "id": "job-001",
                                                "title": "Data Analyst",
                                                "description": "Description for Software Developer",
                                                "city": "Hamburg",
                                                "lat_lon": [
                                                    53.5488,
                                                    9.9872
                                                ],
                                                "type": "Teilzeit",
                                                "requirements": [
                                                    "Master"
                                                ],
                                                "skills": [
                                                    "C#",
                                                    ".NET",
                                                    "Angular"
                                                ],
                                                "salary": 49000,
                                                "postDate": "2003-10-31T01:30:00.000Z",
                                                "deadline": "2023-07-14",
                                                "promotion": true }, null, 2);
        })
        const toggleOpacity = (inputFormat) => {
            for (const format in opacities) {
                if (format === inputFormat) {
                    opacities[format].value = 'opacity-100';
                } else {
                    opacities[format].value = 'opacity-25';
                }
            }
            selectedFormat.value = inputFormat;
        };
        const showLink = computed(() => {
            return selectedFormat.value === 'Link';
        });
        const showUpload = computed(() => {
            return selectedFormat.value === 'Files';
        });
        const showEditor = computed(() => {
            return selectedFormat.value === 'Paste';
        });
        const isValidEmail = computed(() => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(email.value === '')
                return true
            else
                return emailRegex.test(email.value);
        });
        const isValidLink = computed(() => {
            return (link.value !== '');
        });
        watch(isValidEmail, (newValue) => {
            if(newValue && email.value === '')
                isEmail.value=false
            else if(newValue && email.value != '')
                isEmail.value=true
            else
                isEmail.value=false
        });
        watch(isValidLink, (newValue) => {
            if(newValue)
                isLink.value=true
            else
                isLink.value=false
        });
        const handleFileUpload = (event) => {
            const files = event.target.files;
            for (const element of files) {
                const MB = (element.size) / (1024 * 1024);               
                if(MB < 120){
                    if(uploadedFiles.value.length < 1)
                        uploadedFiles.value.push(element);
                }else{
                    alertUpload.value=true;
                    return;
                }
            }
        };
        const onChange = (newContent) => {
            // Detect the data type
            if (isXml(formJson.value)) {
                dataType.value = 'XML';
                editorLang.value = 'xml';
            } else if (isYaml(formJson.value)) {
                dataType.value = 'YAML';
                editorLang.value = 'yaml';
            } else {
                dataType.value = 'javascript';
                editorLang.value = 'javascript';
            }
        };
        const isXml = (content) => {
            return !!(content.startsWith('<?xml') || content.startsWith('<'));           
        };
        const isYaml = (content) => {
            if ((content.includes(':') || content.includes('-')) && !isXml(content) && !isJavaScript(content)) {
                try {
                    jsYaml.load(content);
                    return true;
                } catch (error) {
                    return false;
                }
            }
            return false;
        };
        const isJavaScript = (content) => {
            try {
                JSON.parse(content);
                return true;
            } catch (error) {
                return false;
            }
        };
        const triggerFileInput = () => {
            const input = document.querySelector('.drop-zone__input');
            input.click();
        };
        const handleDrop = (event) => {
            event.preventDefault();
            const files = event.dataTransfer.files;
            for (const element of files) {
                const MB = (element.size) / (1024 * 1024);               
                if(MB < 120){
                    if(uploadedFiles.value.length < 1)
                        uploadedFiles.value.push(element);
                }else{
                    alertUpload.value=true;
                    setTimeout(() => {
                        alertUpload.value=false;
                    },2500)
                    return;
                }
            }
        };
        const deleteFile = (index) => {
            uploadedFiles.value.splice(index, 1);
        };
        const getData = (id) => {
        const url =statusUrl+id
        RestResourceService.getResources(url)
            .then((response) => {
                if (response.data.state === 'launcher') {
                    if(response.data.data.welcomeMessage)
                        welcomeMessage.value=response.data.data.welcomeMessage
                    statusPage.value = false;
                    launcherPage.value = true;
                } else {
                    if(response.data.data.statusMessage)
                        statusMessage.value=response.data.data.statusMessage
                    steps.value=response.data.data.steps
                    stepsbutton.value=response.data.data.button
                    launcherPage.value = false;
                    statusPage.value = true;
                }
            })
            .catch((error) => {
                launcherPage.value = true;
                statusPage.value = false;
                throw new Error(error);
            })
        };
        const submit = async () => {
            if(email.value && isValidEmail.value){
                if(!agreeChecked.value){
                    checkBoxStyle.value='border-color:#dc3545;'
                    return;
                }
                let payload = {
                    email:email.value,
                    data:{},
                    id:uuid.value
                }
                if (selectedFormat.value === 'Paste') {
                    
                        if(isJavaScript(formJson.value)){
                            try {
                                payload.data.editor = JSON.parse(formJson.value) 
                            } catch (error) {
                                payload.data.editor = formJson.value; 
                            }
                        }else if (dataType.value==='YAML') {
                            try {
                                payload.data.editor = jsYaml.load(formJson.value);
                            } catch (error) {
                                payload.data.editor = formJson.value; 
                            }
                        }else{
                            payload.data.editor = formJson.value;
                        }
                    
                } else if (selectedFormat.value === 'Link') {
                    if(link.value.trim() !== ''){
                        payload.data.link = link.value;
                    }
                    else{
                        isLink.value=false; 
                        return;
                    }
                }
                payload.data.comment = comment.value;
                showOverlay.value=true;
                loader.value=true;
                try {
                    // File upload logic
                    if (uploadedFiles.value.length > 0 && selectedFormat.value === 'Files') {
                        const formData = new FormData();
                        formData.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                        formData.append('file', uploadedFiles.value[0]); // Assuming single file upload, modify if multiple
                        const response = await axios.put(submitFilesUrl, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        });
                        payload.id = response.data.id;
                        loader.value=false;
                    } else {
                        const response = await RestResourceService.updateResources(submitUrl, payload);
                        loader.value=false;
                        payload.id = response.data.id;
                    }
                    uuid.value = payload.id;
                    setTimeout(() => {
                        router.push({ path: `/console/launcher/${uuid.value}` });
                        window.uuid = uuid.value;
                        getData(uuid.value);
                        showOverlay.value=false;
                    }, 2000);
                } catch (error) {
                    //console.error('Error during submission:', error);
                    launcherPage.value = true;
                    statusPage.value = false;
                    showOverlay.value=false;
                    loader.value=false;
                    throw new Error(error);
                }
            }else{
                if(!agreeChecked.value){
                    checkBoxStyle.value='border-color:#dc3545;'
                }
                isEmail.value=false; 
                const emailInput = document.getElementById('emailInputValue');
                emailInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        };

        return {
            showOverlay,
            loader,
            dataType,
            stepsbutton,
            editorLang,
            steps,
            checkBoxStyle,
            launcherPage,
            showIdTooltip,
            showLinkTooltip,
            statusPage,
            showEditor,
            showUpload,
            showLink,
            uploadedFiles,
            selectedFormat,
            comment,
            agreeChecked,
            isValidEmail,
            isValidLink,
            isLink,
            isEmail,
            opacities,
            email,
            link,
            welcomeMessage,
            statusMessage,
            uuid,
            formJson,
            alertUpload,
            handleFileUpload,
            triggerFileInput,
            toggleOpacity,
            handleDrop,
            deleteFile,
            onChange,
            getData,
            hiddenUrl,
            submit
        };
     }
   };
 </script>
<style lang="scss">
    @import "~@fortawesome/fontawesome-free/css/all.min.css";
    @import "~bootstrap/dist/css/bootstrap.min.css";
    @import '~bootstrap-vue-next/dist/bootstrap-vue-next.css';

    html, body {
        height: 100%;
        overflow: hidden; 
    }
    ::-webkit-scrollbar {
        width: 12px; 
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1; 
        border-radius: 10px; 
    }

    ::-webkit-scrollbar-thumb {
        background: #3497db; 
        border-radius: 10px; 
        border: 3px solid #f1f1f1; 
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #1e70b3; 
    }
    * {
        scrollbar-width: thin; 
        scrollbar-color: #3497db #f1f1f1; 
    }
    .background {
         background-image: url('@/assets/brand/qsc-mountain.png');
         background-size: cover;
         background-position: center;
         position: fixed;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         z-index: -1;
         background-color: rgba(255, 255, 255, 0.3);
         background-blend-mode: overlay;
     }
     .launcher-page {
         position: relative; 
         height: calc(100vh - 30px);
         overflow: auto;
         margin: 20px; 
     }  
     .company-logo {
         max-width: 415px; 
         height: auto;
         margin-bottom: -5px;
     }
     .option {
         display: inline-flex;
     }
     .label {
         display: block;
         text-align: left;
         font-weight: bold;
         font-size: 14px;
         font-family: Arial, Helvetica, sans-serif;
         margin-bottom: -21px;
         color: #283c54;
     }
     .form-check-input {
        cursor: pointer;
        border-color: #283c54;
     }
     .form-check-input:checked {
        background-color: #3497db !important;
        border-color: #3497db !important;
     }
     .form-control{
        border-color: #283c54;
     }  
     .form-container {
         padding: 20px; 
         background-color: rgba(255, 255, 255, 0.9);
         border-radius: 10px;
         max-width: 800px; 
         width: calc(100% - 40px); 
         margin: 20px auto;
         height: auto;
         box-shadow: 0 0 20px rgba(68, 150, 255, 0.39);
         text-align: center;
         overflow: visible; 
         position: relative; 
         z-index: 1;
     }
     .drop-zone {
         height: 160px;
         padding: 25px;
         display: grid;
         align-items: center;
         justify-content: center;
         text-align: center;
         font-family: "Quicksand", sans-serif;
         font-weight: 500;
         font-size: 20px;
         cursor: pointer;
         color: #4e6d91;
         border: 4px dashed #3497db;
         border-radius: 10px;
     }
     .drop-zone__input {
         display: none;
     }
     .uploaded-files {
         display: grid;
         justify-content: center;
         align-items: center;
         color:#283c54;
     }
     .uploaded-file {
         display: flex;
         align-items: center;
     }
     .copyTooltip {
        position: absolute;
        background-color: #fff;
        color: grey;
        padding: 3px;
        white-space: nowrap;
        border: solid 1px grey;
        border-radius: 4px !important;
        font-size: 10px;
        height: 22px;
        z-index: 999;
    }
     .launch {
        background-color: #3497db !important;
        border-color: #3497db !important;
        color: white !important;
     }
     .launch:hover {
        background-color: #3497db;
        border-color: #3497db;
        color: white;
     }
     .wrapper {
        display: flex;
        flex-direction: column;
        min-height: 100%;
    }
     .file-name {
         margin-right: 10px;
         font-size: 16px;
     }
     .delete-icon {
         cursor: pointer;
         font-size: 15px;
     }
     .circle{
         cursor: pointer;
         font-size: 23px;
         color: #3497db;
     }
     .fa-circle-info{
         cursor: pointer;
         font-size: 14px;
     }
     .link{
        color: #3497db !important;
     }
     .fa-youtube{
        margin-top: -40px;
     }
    .consultat-img{
        border-radius: 40px 15px 40px 15px !important;
     }
     .close-icon {
        cursor: pointer;
        font-size: 1em; 
    }
     .form-label{
        font-size: 13px;
        color: #283c54 !important;
     }
    .status-container {
      text-align: left; 
      color: #283c54;
    }
    
    .StepProgress {
        position: relative;
        padding-left: 63px;
        list-style: none;
        margin-top: 2rem !important;

        &::before {
            display: inline-block;
            content: '';
            position: absolute;
            top: 0;
            left: 39px;
            width: 10px;
            height: 100%;
            border-left: 2px solid #CCC;
        }

        &-item {
            position: relative;
            counter-increment: list;
            padding-left: 30px;

            span {
            max-width: 30vw;
            display: block;
            }

            &:not(:last-child) {
            padding-bottom: 30px;
            }

            &::before {
            display: inline-block;
            content: '';
            position: absolute;
            left: -32px;
            height: 100%;
            width: 10px;
            }

            &::after {
            content: counter(list);
            display: inline-block;
            position: absolute;
            top: 0;
            left: -37px;
            width: 30px;
            height: 30px;
            text-align: center;
            color: #3497db;
            line-height: 25px;
            border: 2px solid #3497db;
            border-radius: 50%;
            background-color: #FFF;
            }

            &.is-done::before {
            border-right: 2px solid #3497db;
            }

            &.is-done::after {
            content: "\f00c"; 
            font-family: "Font Awesome 5 Free"; 
            font-weight: 900;
            font-size: 17px;
            color: #FFF;
            border-color: #3497db;
            background-color: #3497db;
            }

            &.current::after {
            content: '';
            line-height: 25px;
            font-size: 18px;
            color: #3497db;
            border-color: #CCC;
            border-right: 2px solid #CCC;
            }

            &:last-child::before {
            border-right: 2px solid #fff; 
            }
        }
    }

     @media (max-width: 991px) {
        .toolsButtons{
            margin-bottom: 15px; 
        }
    } 
    .launcher-page .mobile-consultat-img {
        display: none;
    }
    @media (max-width: 992px) {
        .launcher-page .mobile-consultat-img {
            display: block;
        }
        .launcher-page .desktop-consultat-img {
            display: none;
        }
    }
    @media (max-width: 591px) {
        .StepProgress {
            padding-left: 15px !important;
            &::before {
                left: -9px;
                height: 94%;
            }
            &-item {
            padding-left: 25px;
            span{
                max-width: 40vw;
                }
            }
        }
    }
</style>
   